import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import { SiteHeader } from "../../components/header/header";
import { useProduct } from "../../services/products/product.context";
import { ItemUpdateCard } from "../../components/containers/update-card";
import { UpdateSearchForm } from "../../components/forms/update-search";
import { AppAlert } from "../../components/utils/alert";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { FooterComponent } from "../../components/footer/footer";


export const ProductUpdate = () => {
    const navigateTo = useNavigate();

    const {
        someProducts,
        pageNum,
        handlePrevPage,
        handleNextPage,
        deleteProduct
    } = useProduct();

    const { token } = useAuthentication();

    const [onAlert, setOnAlert] = useState();
    const [searchRes, setSearchRes] = useState();

    const [products, setProducts] = useState([]);


    useEffect(() => {
        (async () => {
            const data = someProducts;
            setProducts(data);
        })();
    }, [someProducts]);

    const handlePromptDeletion = (product) => {
        setOnAlert({
            caption: 'Delete Product',
            message: `Do you wish to permanently delete data for ${product?.designation}? This action is irreversible!`,
            accept: "Delete",
            reject: "Cancel",
            onAccept: async () => {
                await deleteProduct(product?._id, product?.images, token)
                setOnAlert();
            },
            onReject: () => setOnAlert()
        })
    }

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'CATEGORIES'} />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onClose={() => setOnAlert()}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                />
            )}
            <div className="page-titles">
                <div className="thin-text f-hero">Update/Delete a product</div>
            </div>
            <UpdateSearchForm
                onSearch={(v) => setSearchRes(v)}
                handleCancel={() => setSearchRes()}
            />
            <div className="prod-section">

                <div className="filtered-products">

                    <div className="slogan-1">
                        {searchRes ? searchRes?.designation : "Products"}
                    </div>
                    <div style={{ height: 24 }} />
                    {!searchRes ?
                        <div>
                            {products?.length === 0 ?
                                <div className="no-product sp-3-st">
                                    <div className="slogan-2">No Products to display</div>
                                </div> :
                                <div className="catalog">
                                    {products?.map((item) => (
                                        <ItemUpdateCard
                                            key={item?._id}
                                            onUpdate={() => navigateTo("/updateproduct", { state: item })}
                                            onDelete={() => handlePromptDeletion(item)}
                                            item={item}
                                            onClick={() => navigateTo("/details", { state: item })}
                                        />
                                    ))}
                                </div>
                            }
                        </div> : (
                            <ItemUpdateCard
                                key={searchRes?._id}
                                onUpdate={() => navigateTo("/updateproduct", { state: searchRes })}
                                onDelete={() => handlePromptDeletion(searchRes)}
                                item={searchRes}
                                onClick={() => navigateTo("/details", { state: searchRes })}
                            />
                        )

                    }
                    <div className="pagin-buttons">
                        <button
                            className={classNames("pagin-button", { dis: pageNum === 1 })}
                            onClick={handlePrevPage}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <input
                            type="text"
                            value={pageNum}
                            id=""
                            className={classNames("page-num", { dis: pageNum === 1 && products?.length < 20 })}
                        />
                        <button
                            className={classNames("pagin-button", { dis: products?.length < 20 })}
                            onClick={handleNextPage}
                        >
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                </div>

            </div>
            <FooterComponent />
        </div>
    )
}